import { FuelCard, FuelSign, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import TextLink from 'components/ui/TextLink';
import { DS_TOKENS } from 'constants/styled.contants';
import React, { FC } from 'react';
import * as Styled from './styled';

const Approved: FC = () => (
  <FuelCard backgroundColor={DS_TOKENS.color.background.neutral.weak}>
    <div slot="content">
      <FuelFlex defaultProps={{ display: 'flex', flexDirection: 'column', gap: 'km4', padding: 'km8' }}>
        <FuelFlex>
          <FuelSign icon="payment" iconStyle="filled" size="small" color="inverted" />
          <Styled.NegativeSignWrapper>
            <FuelSign icon="risk-management" iconStyle="filled" size="small" color="green" colorIntensity="strong" />
          </Styled.NegativeSignWrapper>
        </FuelFlex>

        <FuelTypography size="heading-sm" weight="bold" data-testid="gr-approved">
          Motorista aprovado na GR Fretebras!
        </FuelTypography>

        <FuelTypography weight="medium">
          Feche com esse motorista e tenha cobertura da Fretebras de até R$20.000 da franquia de seguro em caso de
          sinistro da carga! <TextLink label="Saiba mais" link={process.env.DEPOSIT_GR_LEARN_MORE_URL} externalRoute />
        </FuelTypography>
      </FuelFlex>
    </div>
  </FuelCard>
);

export default Approved;
